import React, { useMemo, useState } from "react";
import styles from "./HistoryTab.module.css";
import { I18nTranslate } from "../../../../../../i18n";
import { translate, translateElapsed } from "../../../../../../../providers";
import { CustomButton } from "../../../../../../buttons";
import CustomDialog from "../../../../../custom-dialog/CustomDialog";
import { icon } from "../../../../../../icon-component";

export default function HistoryRow({ element, row, historyHeaderTitleKey = "", onRollbackAgentResults = null }) {
	const [open, setOpen] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);
	const cancellable = useMemo(
		() => typeof onRollbackAgentResults === "function" && !!row.agentExecutionId,
		[onRollbackAgentResults, row]
	);
	const [isRolledBack, setIsRolledBack] = useState(row.isRolledBack);
	const handleOpen = () => {
		setOpen((prev) => !prev);
	};
	const handleOpenCancelDialog = () => {
		setOpenDialog((prev) => !prev);
	};
	const handleCancelAction = () => {
		handleOpenCancelDialog();
		setIsRolledBack(true);
		onRollbackAgentResults({ agentExecutionId: row.agentExecutionId, elementId: element.id });
	};

	return (
		<div className={styles.row}>
			<div className={styles.header}>
				<div>
					<I18nTranslate
						param={{ author: row.displayName, count: row.documentsCount }}
						translationKey={historyHeaderTitleKey}
					/>
					{row?.userPrompt && !open && (
						<span role="presentation" onClick={handleOpen}>
							{translate("common:btn.see-more")}
						</span>
					)}
				</div>
				<div>{translateElapsed({ value: row?.elapsed?.value, unitKey: row?.elapsed?.unit })}</div>
			</div>
			{open && (
				<div className={styles.content}>
					<div className={styles.textContent}>
						{row?.userPrompt?.split("\n").map((s) => (
							<p key={s} className={styles.promptLine}>
								{s || <>&nbsp;</>}
							</p>
						))}
					</div>
					<div className={styles.seeLess}>
						<span role="presentation" onClick={handleOpen}>
							{translate("common:btn.see-less")}
						</span>
					</div>
				</div>
			)}
			{(cancellable || row?.isRolledBack) && (
				<div className={styles.cancelContainer}>
					<span className={styles.canceled__helper}>
						{(row.isRolledBack || isRolledBack) &&
							translate("common:component.ai-config.history-tab.action-canceled")}
					</span>
					<div className={styles.action}>
						<CustomButton
							color="secondary"
							disabled={row.isRolledBack || isRolledBack}
							size="sm"
							variant="outlined"
							onClick={handleOpenCancelDialog}
						>
							{translate("common:component.ai-config.history-tab.cancel-action")}
						</CustomButton>
					</div>
				</div>
			)}
			<CustomDialog
				iconColor="var(--red-500)"
				iconModel={icon.faExclamationTriangle}
				open={openDialog}
				subTitle={<I18nTranslate translationKey="common:component.ai-config.cancel.confirmation.message" />}
				title={translate("common:dialog.cancel.confirmation")}
				onClose={handleOpenCancelDialog}
				onSubmit={handleCancelAction}
			/>
		</div>
	);
}
